import { render, staticRenderFns } from "./calculator-slider.vue?vue&type=template&id=48bb757e&scoped=true&lang=pug"
import script from "./calculator-slider.vue?vue&type=script&lang=js"
export * from "./calculator-slider.vue?vue&type=script&lang=js"
import style0 from "./calculator-slider.vue?vue&type=style&index=0&id=48bb757e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb757e",
  null
  
)

export default component.exports